<template>
  <a-card class="style1">
    <div style="display: flex; justify-content: flex-end">
      <a a :href="apiURL + '/api/v1/list_pasters.csv/?' + filters" style="background-color: #007bff; color: white; border-radius: 5px; padding: 5px 15px; cursor: pointer; margin-bottom: 15px">
        Download CSV
      </a>
    </div>
    <a-table :loading="isLoading" :columns="columns" :data-source="userData" :pagination="pagination1" @change="handleTable1Change" size="middle" bordered rowKey="id">
      <div slot="button_status" slot-scope="text">{{ getButtonStatus(text) }}</div>
      <div slot="action" slot-scope="record" class="action">
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onSendLink(record)" v-if="record.button_status === 'none'">
          <a href="javascript:;" style="background-color: #007bff; color: white; border-radius: 5px; padding: 5px 10px; cursor: pointer">{{
            record.is_resent_link ? 'Send Link again' : 'Send Link'
          }}</a>
        </a-popconfirm>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import { includes, replace, map, split } from 'lodash';
import AdminService from '@/services/AdminService';
import Constants from '@/constants.js';
export default {
  data() {
    const buttonStatus = [
      { text: 'Discount', value: 'discount' },
      { text: 'Calendar', value: 'calendar' },
      { text: 'Free user', value: 'freeuser' },
      { text: 'None', value: 'none' },
    ];
    const columns = [
      {
        title: 'First Name',
        dataIndex: 'firstname',
        key: 'firstname',
        width: 150,
      },
      {
        title: 'Last Name',
        dataIndex: 'lastname',
        key: 'lastname',
        width: 150,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Church Name',
        dataIndex: 'churchname',
        key: 'churchname',
      },
      {
        title: 'Church Phone',
        dataIndex: 'churchphone',
        key: 'churchphone',
      },
      {
        title: 'Cellphone',
        dataIndex: 'cellphone',
        key: 'cellphone',
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'City',
        dataIndex: 'city',
        key: 'city',
      },
      {
        title: 'State',
        dataIndex: 'state',
        key: 'state',
      },
      {
        title: 'ZipCode',
        dataIndex: 'zip_code',
        key: 'zip_code',
      },
      {
        title: 'Button Status',
        dataIndex: 'button_status',
        key: 'button_status',
        scopedSlots: {
          customRender: 'button_status',
        },
        filters: buttonStatus,
        onFilter: (value, record) => includes(record.button_status, value),
      },
      {
        title: 'Action',
        key: 'operation',
        fixed: 'right',
        width: 150,
        scopedSlots: {
          customRender: 'action',
        },
      },
    ].map(item => {
      if (!['status', 'button_status', 'id', 'operation', 'cellphone', 'churchphone'].includes(item.key)) {
        return {
          ...item,
          scopedSlots: {
            ...item.scopedSlots,
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        };
      }
      return item;
    });
    return {
      form: this.$form.createForm(this),
      userList: [],
      userListWithoutStory: [],
      userListWithoutOrderCards: [],
      userListWithoutChurchConnection: [],
      searching: '',
      pagination1: [],
      error: '',
      isLoading: true,
      isEdit: false,
      isVisibleModal: false,
      isVisibleCardAmountModal: false,
      confirmDirty: false,
      isChangedPass: false,
      userData: [],
      userEdit: {},
      buttonStatus: map(buttonStatus, item => ({ label: item.text, value: item.value })),
      columns: columns,
      filters: new URLSearchParams({ limit: 10 }).toString(),
    };
  },
  watch: {
    userList: {
      async handler(val) {
        this.userData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    apiURL() {
      return Constants.API_URL;
    },
  },
  methods: {
    empty,
    convertToJsonString(obj) {
      let queryString = '';
      for (let key in obj) {
        if (Array.isArray(obj[key])) {
          for (let value of obj[key]) {
            queryString += `${key}[]=${value}&`;
          }
        } else {
          queryString += `${key}=${obj[key]}&`;
        }
      }
      // Remove the trailing '&' character
      queryString = queryString.slice(0, -1);
      return queryString;
    },
    downloadCsv() {
      this.fetchPasters({
        is_csv: true,
        ...this.filters,
      });
    },
    createUser() {
      this.isVisibleModal = true;
      this.isEdit = false;
    },
    getButtonStatus(text) {
      text = replace(text, '[', '');
      text = replace(text, ']', '');
      return text;
    },
    async doInitData() {
      await this.fetchPasters();
    },
    handleTable1Change(pagination, filters, sorter) {
      const pager = { ...this.pagination1 };
      pager.current = pagination.current;
      this.pagination1 = pager;
      this.filters = this.convertToJsonString(filters);
      this.fetchPasters({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    async fetchPasters(params = {}) {
      this.isLoading = true;

      const data = await AdminService.user.getPasterAll({
        limit: 10,
        ...params,
      });

      const pagination = { ...this.pagination1 };
      pagination.total = data.total_count;
      this.userList = data.pasters;
      this.pagination1 = pagination;

      this.isLoading = false;
    },
    onEdit(record) {
      this.isEdit = true;
      this.userEdit = record;
      this.isVisibleModal = true;
      let button_status = this.getButtonStatus(record.button_status);
      button_status = split(button_status, ',').map(item => item.trim());
      this.$nextTick(() => {
        this.form.setFieldsValue({
          firstname: record.firstname,
          lastname: record.lastname,
          email: record.email,
          button_status,
        });
      });
    },
    async onSendLink(record) {
      try {
        this.isLoading = true;
        await AdminService.user.sendLink(record.hook_key);

        this.$notification['success']({
          message: 'Sent link successful.',
          description: `The link was sent successfully.`,
        });
        // await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
